// This function accepts a list of subscription objects of any type as the first parameter
// and the current structured subscriptions from state.
//
// The list is will not contain any subscription IDs as they cannot be known ahead of time,
// so the IDs are looked up from the current subscription state object (second parameter)
// and then if there is a matching item, the ID is added to the subscription item from the list.
//
// The filtering is based on if this ID exists or not. If the difference parameter is set to false
// only the elements which have a subscription ID will be retured, i.e the elements we already know
// about, however if set to true, the set difference will be returned between known subscriptions
// and unknown given subscriptions.
export const subscriptionDifference = (addSubscriptions = [], subscriptions = {}, difference = false) =>
  addSubscriptions.map(subscription => {
    const {
      type,
      id
    } = subscription;

    const {
      [type]: {
        [id]: stateSubscription = {}
      } = {}
    } = subscriptions;

    subscription.subId = stateSubscription.subId || 0;
    return subscription;

  }).filter(subscription => {
    if (subscription.subId) {
      return !difference;
    } else {
      return difference;
    }
  });


export function flattenSubscriptions(subscriptions, filters = []) {
  const flatSubscriptions = [];

  filters.forEach(filter => {
    const subscriptionsSubset = subscriptions[filter];
    if (subscriptionsSubset) {
      Object.keys(subscriptionsSubset).forEach(id => {
        flatSubscriptions.push({
          subscription_id: +id,
          subscription_type: filter
        });
      });
    }
  });

  return flatSubscriptions;
}



// WEBPACK FOOTER //
// ./utils/subscriptionUtils.js